import React from 'react';

const TermsOfService = () => {
  return (
    <div className="pt-32 pb-20 px-6 max-w-4xl mx-auto min-h-[70vh]">
      <div className="mb-6 flex items-center gap-4">
        <div className="h-[2px] w-12 bg-lime"></div>
        <span className="font-lexend font-bold text-lime text-xs tracking-[0.4em] uppercase">LEGAL</span>
      </div>
      <h1 className="font-lexend font-extrabold text-4xl text-white mb-10 tracking-tighter uppercase italic">
        TERMS OF <span className="text-pacer-start">SERVICE</span>
      </h1>
      <div className="font-inter text-[#888] space-y-6 leading-relaxed">
        <p>Last Updated: October 2026</p>
        <p>
          Please read these Terms of Service ("Terms") carefully before using the PacerApp website and application.
        </p>
        
        <h2 className="font-lexend font-bold text-white text-xl mt-8 mb-4">1. Acceptance of Terms</h2>
        <p>
          By accessing or using our service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the service.
        </p>

        <h2 className="font-lexend font-bold text-white text-xl mt-8 mb-4">2. Account Registration and Strava Connection</h2>
        <p>
          In order to use certain features of the service, you may be required to register for an account and connect your Strava profile. You agree to provide accurate, current, and complete information during the registration process.
        </p>

        <h2 className="font-lexend font-bold text-white text-xl mt-8 mb-4">3. Medical Disclaimer</h2>
        <p>
          PacerApp provides data analysis and recommendations for athletic performance. However, we do not provide medical advice. Always consult with a qualified healthcare provider before beginning any new training regimen or making significant changes to your current routine.
        </p>

        <h2 className="font-lexend font-bold text-white text-xl mt-8 mb-4">4. Limitation of Liability</h2>
        <p>
          In no event shall PacerApp, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;
